import { addressId } from 'data/mock-data';

const mock = () => ({
  data: {
    addressId,
  },
});

export default mock;
